export default __webpack_public_path__ + "static/media/keyboard_key_4.af3e4a87.png";